/** Static trayecto / fase layout until Strapi exposes malla meta */
import base from "./licenciaturaCourseDetail.json";

export const mallaMetaEspanol = base.meta;
